import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// const ENDPOINT = 'http://aditt.unesc.net.s3-website-us-east-1.amazonaws.com/data/projetos';
const ENDPOINT = '/assets/projetos.json';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  public data = { projetos: [], areasConhecimento: [], tiposProjeto: [] };
  private loaded = false;

  constructor(private http: HttpClient) {
  }

  async getData() {
    if (!this.loaded) {
      await this.loadAllData();
    }

    return this.data;
  }

  async loadAllData() {
    let result = await this.http.get<any>(ENDPOINT).toPromise();
    await this.loadData(result);
  }

  async loadData(projetos) {
    return new Promise((resolve, reject) => {
      this.data.projetos = projetos;
      this.data.areasConhecimento = projetos.map(p => p.areaConhecimento)
        .filter(areaConhecimento => !!areaConhecimento)
        .filter((value, index, self) => self.map(ac => ac["id"]).indexOf(value["id"]) === index);
      this.data.areasConhecimento.forEach((element, i) => {
        let areaConhecimento = this.data.areasConhecimento[i];
        let imageName = 'img.jpg';
        if (areaConhecimento.sigla) {
          imageName = 'img-' + areaConhecimento.sigla.toLowerCase() + '.jpg';
        }
        areaConhecimento.imageName = imageName;
      });
      this.data.tiposProjeto = projetos.map(p => p.tipoProjeto)
        .filter(tipoProjeto => !!tipoProjeto)
        .filter((value, index, self) => self.map(tp => tp["id"]).indexOf(value["id"]) === index);

      console.log(this.data);
      this.loaded = true;
      resolve();
    });
  }


}
